import { Grid, Typography } from '@mui/material';
import React from 'react';
import Breadcrumb from '../../components/Breadcrumbs.component';
import Layout from '../../components/Layout/Layout.component';
import { AdminCards } from './AdminCards/AdminCards.component';
import { AdminCard } from './AdminCards/AdminCards.type';
import { useStyles } from './AdminDashboard.styles';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../utils/routerUrls';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';

export const AdminDashboard: React.FC = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  useDocumentTitle('Strona główna');

  const adminCards: AdminCard[] = [
    {
      icon: <ContactSupportIcon aria-label="pomoc" />,
      title: t('adminDashboard:cards.helpdesk.title'),
      description: t('adminDashboard:cards.helpdesk.description'),
      link: Paths.support,
      ariaLabelMore: 'Przejdź do centrum pomocy',
    },
    {
      icon: <MenuBookIcon aria-label="instrukcja obsługi systemu" />,
      title: `Instrukcja obsługi systemu ${t('global:shortNames.system')}`,
      description: `Podręczniki do pobrania dla użytkowników ${t('global:shortNames.system')}`,
      link: Paths.supportPdf,
      ariaLabelMore: 'Pokaż wszystkie podręczniki',
    },
    {
      icon: <InfoIcon aria-label={`o systemie ${t('global:shortNames.system')}`} />,
      title: `O systemie ${t('global:shortNames.system')}`,
      description: t('adminDashboard:cards.about.description'),
      link: Paths.supportFaq,
      ariaLabelMore: 'Przejdź do listy najczęściej zadawanych pytań',
    },
  ];

  return (
    <Layout viewType={'admin'}>
      <div className={styles.tableAndBreadcrumContainer}>
        <h1 className={styles.breadcrumbHeader}>
          <Breadcrumb />
        </h1>
        <Box sx={{ marginLeft: 3, justifyContent: 'flex-start' }} className={styles.adminBoxContainer}>
          <Grid
            justifyContent="flex-start"
            container
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={styles.adminGridContainer}
          >
            {adminCards.map((card) => (
              <Grid justify-content={'left'} sx={{ minWidth: '330px' }} item xs={12} sm={6} md={4} key={card.title}>
                <AdminCards adminCard={card} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>
    </Layout>
  );
};
